<div class="d-flex" [class.even]="index % 2">
  <div class="history-table-cell align-top">
    <app-user-picture [imageURL]="entry.picture" [active]="'true'" [imageClass]="'caseSummery'">
    </app-user-picture>
    <span class="headline initials" *ngIf="!entry.previousValue">{{ entry.initials }} created a new SOS service with ID
      {{ entry.newValue.id }}
        </span>
    <span class="headline initials" *ngIf="entry.previousValue && !entry.newValue.deletedOn">{{ entry.user?.initials }} updated a SOS service with ID {{ entry.newValue.id }}</span>
    <span class="headline initials" *ngIf="entry.previousValue && entry.newValue.deletedOn">{{ entry.user?.initials }} deleted a SOS service with ID {{ entry.newValue.id }}
        </span>
    <div class="elementDateTime">{{ entry.newValue.modifiedOn | date: 'd MMM y - HH:mm' }}</div>
  </div>
  <div class="history-table-cell align-top">
    <div class="headline">
            <span *ngIf="entry.previousValue">
                Original value
            </span>
    </div>
    <app-previous-value [entry]="entry" [attribute]="'amountExchanged'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'amountLocal'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'approvalDate'" [display]="'date'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'creditorId'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'creditorName'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'documentId'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'dueDate'" [display]="'date'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'erpIdent'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'exchangeRate'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'id'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'internalRemarks'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'invoiceDate'" [display]="'date'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'invoiceNumber'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'progress'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'receivedDate'" [display]="'date'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'recoveryId'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'returnRemark'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'shareOfTotalApplied'"></app-previous-value>
    <app-previous-value [entry]="entry" [attribute]="'status'"></app-previous-value>
  </div>
  <div class="history-table-cell align-top" *ngIf="!entry.newValue.deletedOn">
    <div class="headline">
            <span>
                New value
            </span>
    </div>
    <app-new-value [entry]="entry" [attribute]="'amountExchanged'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'amountLocal'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'approvalDate'" [display]="'date'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'creditorId'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'creditorName'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'documentId'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'dueDate'" [display]="'date'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'erpIdent'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'exchangeRate'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'id'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'internalRemarks'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'invoiceDate'" [display]="'date'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'invoiceNumber'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'progress'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'receivedDate'" [display]="'date'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'recoveryId'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'returnRemark'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'shareOfTotalApplied'"></app-new-value>
    <app-new-value [entry]="entry" [attribute]="'status'"></app-new-value>
  </div>
  <div class="history-table-cell align-top" *ngIf="entry.newValue.deletedOn">
    <div class="headline">
            <span class="red-text">
                Deleted
            </span>
    </div>
  </div>
</div>
